import { DisplayGrid, GridType } from 'angular-gridster2';
import { WizDraggableComponent, WizDropItemEvent, WizDraggableItem } from '@wizeoo/akm-component-lib';
import { Directive, Input, ChangeDetectorRef, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { GridsterComponent } from 'angular-gridster2';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { EM_ACTION } from '@wizeoo/akm-compute-lib';
import { Model } from '../../../../model/model';
import { PhysicalTemplateEngine } from '../../../../manager/workingzone/physical-template.engine';
import { IWidget } from '../../../../manager/widgets/i-widget';

// event de mise à jour d'un élément du gridster
export interface gridsterItemEvent {
  item: GridsterWidgetItem,
  action: EM_ACTION
}

@Directive()
export abstract class FormWidgetGridsterComponent implements OnInit, WizDraggableComponent {

  @ViewChild('gridster', { read: GridsterComponent, static: true })
  public gridster: GridsterComponent;

  constructor(protected cdref: ChangeDetectorRef) { }

  @Input() widget: IWidget;
  @Input() model: Model;

  // couleur de fond, selon le mode (édition / travail)
  get _backgroundColor(): string {
    return this._templatingMode ? 'var(--grid-border-color);' : '#ffffff';
  }

  options: any = PhysicalTemplateEngine.gridsterSafe();
  nbCols: number = 0;
  nbRows: number = 0;


  /** contrôle de cohérence du drop */
  abstract checkDragOver(event: WizDropItemEvent): boolean;

  onMoveItemAfterDrag(_: WizDropItemEvent): void {}
  onRemoveItemAfterDrag(_: WizDraggableItem): void { }
  abstract onAddItemAfterDrag(pEvent: WizDropItemEvent): void;

  private _templatingMode: boolean = false;
  public get templatingMode(): boolean {
    return this._templatingMode;
  }

  @Input() set templatingMode(value: boolean) {
    this._templatingMode = value;
  }

  public calculatedTabIndex(item: GridsterWidgetItem): number {
    // on multiplie l'ordre en y par 100 pour ne pas avoir d'overlapping. On ajoute 1 pour gérer le cas du tabIndex 0 qui corrompt la navigation par Tab
    // if((item.field as any).code === 'SUPPLIER') {
    //   console.log('supplier',item);
    // } 
    return item.x + item.y * 100 + 1;
  }


  protected _widgets: GridsterWidgetItem[] = []; // la collection de widgets du template, pour alimentation de gridster
  public get widgets(): GridsterWidgetItem[] {
    // la collection de widgets du template, pour alimentation de gridster
    // on tri la collection par position, pour gestion correcte des tabIndex...
    if(this._widgets?.length > 0) {   
      this._widgets.sort((a,b) => {
        return this.calculatedTabIndex(a) - this.calculatedTabIndex(b);
      })
    }
    return this._widgets;
  }
  @Input() set widgets(value: GridsterWidgetItem[]) {
    this._widgets = value;
    this.updateOptions();
  }

  // dispatch des events sur éléments
  @Output() widgetsChanged = new EventEmitter<gridsterItemEvent>();

  ngOnInit(): void {
    this.updateOptions();
  }

  public updateOptions(forcedMode: GridType = null) {
    // options de configuration de gridster (toutes les options possibles)
    this.options = PhysicalTemplateEngine.gridsterSafe();

    // console.log('gridster opts')
    let dimensions: { cols: number, rows: number } = { cols: 60, rows: 100};// 1cell = 20px x 20px soit 1200px x 2000px

    // calcul de la taille nécessaire
    if (!this.templatingMode && !!this._widgets && this._widgets.length > 0) { // en mode templating, on prend la matrice complète
      let maxX: number = 0;
      let maxY: number = 0;

      this._widgets.forEach((item: any) => {
        if(!!item) {
          // console.log(item.cod, item.x, item.cols, item.y, item.rows);
          const askedX: number = item.x + item.cols;
          const askedY: number = item.y + item.rows;
          if(!!askedX && askedX > maxX) {
            maxX = askedX;
          }
          if(!!askedY && askedY > maxY) {
            maxY = askedY;
          }
        } else {
          // console.log('what', this._widgets);
        }

      });
      dimensions.cols = maxX;
      dimensions.rows = maxY;
      this.options.addEmptyRows = false;
      this.options.pushItems = true;
      this.options.compactType = 'compactUp';
    }


    // mode de rendu forcé
    let userGridType: GridType = GridType.Fixed;
    if(forcedMode) {
      userGridType = forcedMode;
    }

    // template de base pour le gridster
    this.options.displayGrid = this.templatingMode ?  DisplayGrid.Always : DisplayGrid.None;
    this.options.gridType = this.templatingMode ? GridType.Fixed : userGridType; //;
    this.options.minCols = dimensions.cols;
    this.options.minRows = dimensions.rows;
    this.options.maxCols = dimensions.cols;
    this.options.maxRows = dimensions.rows;
    this.options.maxItemCols = 60;
    this.options.maxItemRows = 100;
    this.options.minItemRows = 1;
    this.options.minItemCols = 2;
    this.options.defaultItemCols = 6;
    this.options.defaultItemRows = 3;
    // this.options.maxItemCols = this.options.maxItemRows = this.options.minItemRows = this.options.minItemCols = 1;
    this.options.fixedRowHeight = 20; // this._templatingMode ? 90 : 60;
    this.options.fixedColWidth= 20,
    this.options.margin = 5;
    this.options.swap = this.templatingMode;
    this.options.keepFixedHeightInMobile = false;
    this.options.mobileBreakpoint = 50; // taille minimale pour fonctionner
    // opts.compactType = CompactType.CompactLeftAndUp;
    this.options.resizable = {
      enabled: this.templatingMode,
      handles: {
        se: true, // coin bas-droite
        ne: true, // coin haut-droite
        sw: true, // coin bas-gauche
        nw: true, // coin haut-gauche

        // Désactive tous les bords
        n: false,
      }
    };
    this.options.draggable = {
      enabled: this.templatingMode,
      ignoreContent: false,
      dragHandleClass: 'freedata-gridster-header'
    };

    // console.log('gridster dims', this.options);
    this.options.itemChangeCallback = this.onItemMovedOrResized.bind(this); // (component) => this.widgetsChanged.emit(this._widgets); // écouteur sur modif
    this.options.api?.optionsChanged(); // on signale qu'on a changé ?
  }

  // prise de la hauteur réellement nécessaire
  public get realHeight(): number {
    let realheight: number = (this.options?.maxRows) * (this.options?.fixedRowHeight + this.options.margin);
    // console.log('gridster realheight',this.options, realheight);
    return realheight;
  }

  /** déplacement ou resize d'un widget */
  protected onItemMovedOrResized(item, itemComponent) {
    // console.log('onItemMovedOrResized subGridster', item);
    this.widgetsChanged.emit({item, action: EM_ACTION.UPDATE}); // this._widgets)
    // this.onItemChange(new WizEvent(null, null, item));
  }


  onGridSizeChanged(cols, rows): void {
    // console.log('onGridSizeChanged', cols, rows);
  }

  onItemDeleted(item: GridsterWidgetItem) {
    
    // console.log('onItemDeleted subGridster', item);
    // this._widgets.splice(this._widgets.indexOf(item), 1);
    this.widgetsChanged.emit({item, action: EM_ACTION.DELETE }); //this.widgetsChanged.emit(this._widgets);
  }
  onItemUpdated(item: GridsterWidgetItem) {
    // console.log('onItemUpdated subGridster', item);
    const conf = this._widgets[this._widgets.indexOf(item)];
    // console.log('itemUpdate', conf);
    this.widgetsChanged.emit({item, action: EM_ACTION.UPDATE}); //this.widgetsChanged.emit(this._widgets);
  }
  
  /**
   * pour masquer le scroll sur les tiles
   */
  public get overflow(): string {
    if(!!this.templatingMode) {
      return "auto";
    } else {
      return "hidden";
    }
  }

}
